import { render, staticRenderFns } from "./Mgid.vue?vue&type=template&id=884848e0"
import script from "./Mgid.vue?vue&type=script&lang=js"
export * from "./Mgid.vue?vue&type=script&lang=js"
import style0 from "./Mgid.vue?vue&type=style&index=0&id=884848e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports